import { analyticsService } from "@services/analyticsService";
import {
  WSButton,
  WSCard,
  WSControlGroup,
  WSForm,
  WSInputTextarea,
  WSList
} from "@wingspanhq/fe-component-library";
import { forwardRef, useImperativeHandle, useRef } from "react";

const dismissalReasons = [
  "I handle taxes through my spouse's W-2 withholding",
  "I have an existing system with my accountant/CPA",
  "My income is too irregular or seasonal to set a fixed %",
  "I don't meet the $1,000 annual tax threshold",
  "The calculated rate seems too high/low",
  "I don't understand how this feature works",
  "I use another tax savings tool",
  "Other"
];

export type CardOptOutSurveyRef = {
  submit: () => void;
};

export const CardOptOutSurvey = forwardRef<CardOptOutSurveyRef>((_, ref) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  useImperativeHandle(ref, () => ({
    submit: () => {
      buttonRef.current?.click();
    }
  }));

  return (
    <WSCard
      header={{
        label: {
          text: "Reason for opting out",
          helperText:
            "Your feedback helps us improve the benefits we offer our contractors. Please share why tax withholding doesn't work for you right now:"
        }
      }}
    >
      <WSForm
        defaultValues={{
          reason: "",
          comment: ""
        }}
        onSubmit={data => {
          analyticsService.track("Tax Withholding Setup Dismissed", {
            reason: data.reason || "Other",
            comment: data.comment
          });
        }}
      >
        <WSList gap="XL">
          <WSForm.Field
            name="reason"
            component={WSControlGroup}
            componentProps={{
              options: dismissalReasons.map(reason => ({
                value: reason,
                label: reason
              })),
              type: "radio"
            }}
          />

          <WSForm.Field
            name="comment"
            component={WSInputTextarea}
            componentProps={{
              label: "Additional comments (optional)",
              placeholder: "Provide specific details about the decision"
            }}
          />

          <WSButton style={{ display: "none" }} ref={buttonRef} type="submit">
            Submit
          </WSButton>
        </WSList>
      </WSForm>
    </WSCard>
  );
});
